/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import { Form, Message } from 'semantic-ui-react';

const ComplaintViewClient = ({ complaint }) => {
  return (
    <>
      <Message attached header="Numéro de confirmation" content={complaint.confirmation} />

      <Form.Group widths="equal">
        <Form.Input fluid label="Prénom" value={complaint.firstname} />
        <Form.Input fluid label="Nom" value={complaint.lastname} />
        <Form.Input fluid label="Email" value={complaint.email} />
        <Form.Input fluid label="Date de création" value={complaint.createdAt} />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Input fluid label="Compagnie" value={complaint.company} />
        <Form.Input fluid label="Type de la plainte" value={complaint.complaintType} />
        <Form.Input fluid label="Telephone" value={complaint.phone} />
      </Form.Group>
      <Form.Input label="Objet de la plainte" value={complaint.object} />
      <Form.TextArea label="Description de la plainte" value={complaint.description} />
    </>
  );
};

export default ComplaintViewClient;
